import { CancelOutlined } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { FlexBox } from 'components/Box'
import { UploadErrors } from '../hooks/useUploadAdUnitsConfiguration'

type Props = {
  errors: UploadErrors
  filename: File['name']
}

export const DialogContentFailure = ({ errors, filename }: Props): React.JSX.Element => {
  const { t } = useTranslation('features/domain')

  return (
    <FlexBox axis='xy'>
      <CancelOutlined
        data-cy='cancel-outlined-icon'
        sx={{
          color: theme => theme.palette.error.main,
          fontSize: 75,
          pb: 2,
        }}
      />

      <Typography variant='h6'>
        {t('form.general.bulkManagement.dialog.upload.error.title', {
          filename,
        })}
      </Typography>

      <Box>
        <Typography sx={{ py: 2 }}>
          {t('form.general.bulkManagement.dialog.upload.error.description')}
        </Typography>

        {errors.map((err: string) => (
          <Typography
            key={err}
            variant='body2'
          >
            {err}
          </Typography>
        ))}
      </Box>
    </FlexBox>
  )
}
